var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8306_86414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9948 0H0V20H19.9948V0Z",
    fill: "#232E5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.17094 9.28535C3.12304 9.28535 3.07409 9.28535 3.02515 9.28535L3.03973 6.92285C4.94236 6.93535 6.06602 6.69368 6.59817 6.16452C7.36985 5.39681 7.36672 3.50827 7.36256 0.648893V0.0166016H9.72444V0.644727C9.72965 4.09681 9.73277 6.37702 8.26441 7.83848C7.24905 8.84993 5.72028 9.28431 3.17094 9.28431",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27146 16.9227L6.90958 16.9154C6.91583 15.0185 6.6711 13.8862 6.13895 13.3539C5.36831 12.5821 3.4813 12.5821 0.635171 12.5883H0.00512695V10.2269H0.631006C4.07073 10.2237 6.34618 10.2185 7.81039 11.6852C8.84241 12.7196 9.27979 14.2862 9.27146 16.9237",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5561 19.9655H10.1942V19.3384C10.189 15.8863 10.1859 13.6051 11.6542 12.1436C12.6894 11.1134 14.2588 10.6728 16.8935 10.6978L16.8789 13.0603C14.9794 13.0467 13.8526 13.2894 13.3215 13.8186C12.5498 14.5863 12.553 16.4759 12.5571 19.3353V19.9655H12.5561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8128 9.75749C15.6834 9.75749 13.5788 9.68353 12.1958 8.29811C11.1638 7.26374 10.7264 5.69707 10.7347 3.05957L13.0966 3.06686C13.0904 4.96478 13.3351 6.09603 13.8673 6.62936C14.6379 7.40124 16.5228 7.40019 19.371 7.39499H20.0011V9.75645H19.3742C19.1836 9.75645 18.9961 9.75645 18.8128 9.75645",
    fill: "#70C1AC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8306_86414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.de44861e02b8e7697f2e5f0ed483c9da.svg";
export { ForwardRef as ReactComponent };